import FAQDialog from './FAQDialog';
export default FAQDialog;
